export default __webpack_public_path__ + "446ea183ab98a6fd08d6fc8f5d038505.woff";